import { constant } from './UserProfileActionsConstant'
import { APIDirectory, HTTP } from '../../rest'
/**
 * get userProfile list is triggered
 */
export const userProfileFetchInProgress = () => {
  // l;
  return {
    type: "USER_PROFILE_FETCH_IN_PROGRESS"
  }
}

/**
 * get userProfile list is completed
 * @param {*} data --  userProfile list items 
 */

export const userProfileFetchComplete = (userProfileDetails) => {
  return {
    type: constant.USER_PROFILE_FETCH_IN_COMPLETE,
    data: userProfileDetails
  }
}

export const userProfileFetchFailed = () => {
  return {
    type: constant.USER_PROFILE_FETCH_IN_FAILED
  }
}


export const getUserProfileByCognitoId = (cognitoId) => {
  return async dispatch => {
    try {
      dispatch(userProfileFetchInProgress());
      let userProfileDetails = await HTTP.GET(APIDirectory.getUserProfileByCognitoId(cognitoId));
      if (userProfileDetails != null) {
        dispatch(userProfileFetchComplete(userProfileDetails));
        if (userProfileDetails.activeProfileType != undefined) {
          dispatch({
            type: constant.SET_ACTIVE_PROFILE_TYPE,
            data: userProfileDetails.activeProfileType
          })
        }
        if (userProfileDetails.activeSchool != undefined) {
          dispatch({
            type: constant.SET_ACTIVE_SCHOOL,
            data: userProfileDetails.activeSchool
          })
        }
        return userProfileDetails;
      }
      else {
        dispatch(userProfileFetchFailed());
      }
    } catch (error) {
      return [];
    }
  };
}

export const updateUserActiveSchool = (ownerId, email, activeSchool, profileType) => {
  return async dispatch => {
    try {
      dispatch(updateUserActiveSchoolInProgress())
      let userProfileDetails = await HTTP.POST(APIDirectory.updateActiveSchoolURL(ownerId), { email: email, activeSchool: activeSchool, profileType: profileType });
      // dispatch(updateUserActiveSchoolComplete(userProfileDetails))
    } catch (error) {
      throw error
    }
  }
}

export const updateUserActiveSchoolInProgress = () => {
  return {
    type: constant.UPDATE_USER_ACTIVE_SCHOOL_IN_PROGRESS
  }
}

export const updateUserActiveSchoolComplete = (userProfileDetails) => {
  return {
    type: constant.UPDATE_USER_ACTIVE_SCHOOL_COMPLETE,
    data: userProfileDetails
  }
}

export const setActiveProfileType = activeProfileType => {
  return {
    type: constant.SET_ACTIVE_PROFILE_TYPE,
    data: activeProfileType
  }
}



export const updateProfileInProgress = () => {
  return {
    type: constant.UPDATE_PROFILE_IN_PROGRESS
  };
};

export const updateProfileComplete = data => {
  return {
    type: constant.UPDATE_PROFILE_IN_COMPLETE,
    data: data
  };
};

export const updateUserProfile = (userData) => {
  return async dispatch => {
    try {
      let userCognitoId = userData.cognitoId
      dispatch(updateProfileInProgress());
      let url = APIDirectory.getUserProfileByCognitoId(userCognitoId);
      let updateProfileResult = await HTTP.PUT(url, JSON.stringify(userData));
      dispatch(updateProfileComplete(updateProfileResult));
      return updateProfileResult;
    } catch (error) {
      throw error
    }
  };
};


export const sendEmail = (emailId, transferOwnerId, schoolId) => {
  return async dispatch => {
    try {
      let url = APIDirectory.sendEmail(emailId, transferOwnerId, schoolId);
      let response = await HTTP.GET(url)
      return response;
    }
    catch (error) {
      throw error;
    }
  }
}

export const reuestRejectedEmail = (emailId, transferOwnerId, schoolId) => {
  return async dispatch => {
    try {
      let url = APIDirectory.sendEmailForReject(emailId, transferOwnerId, schoolId);
      let response = await HTTP.GET(url)
      return response;
    }
    catch (error) {
      throw error;
    }
  }
}

export const makeOwner = (transferOwnerId) => {
  return async dispatch => {
    try {
      dispatch(makeOwnerInProgress())
      let url = APIDirectory.acceptOwnerInviteUrl(transferOwnerId);
      let response = await HTTP.GET(url);
      if (response.status == 200) {
        dispatch(makeOwnerSuccess(response.data));
      }
      else {
        dispatch(makeOwnerFailure())
      }
      return response;

    }
    catch (error) {
      dispatch(makeOwnerFailure())
    }
  }

}

export const makeOwnerInProgress = () => {
  return {
    type: constant.MAKE_OWNER_IN_PROGRESS
  }
}

export const makeOwnerSuccess = (data) => {
  return {
    type: constant.MAKE_OWNER_SUCCESS
  }
}

export const makeOwnerFailure = () => {
  return {
    type: constant.MAKE_OWNER_FAILURE
  }
}
